import { openDB } from "./indexedDb";
// import api from "../components/api";
// import { isOnline } from "./network";
import { isBackendReady } from "./network";
import { submitAudiometryData } from "../components/api";

/* ---------- SAVE OFFLINE ---------- */
export async function saveAudiometryOffline(data) {
  console.log("💾 Saving audiometry offline…", {
    patient_excel_id: data.patient_excel_id
  });

  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("audiometry", "readwrite");
    const store = tx.objectStore("audiometry");

    store.add({
      ...data,
      synced: 0,
      created_at: new Date().toISOString(),
    });

    tx.oncomplete = () => {
      console.log("✅ Audiometry saved offline successfully");
      resolve(true);
    };

    tx.onerror = () => {
      console.error("❌ Failed to save audiometry offline", tx.error);
      reject(tx.error);
    };
  });
}



function base64ToBlob(base64, type = "application/pdf") {
  if (!base64) return null;

  const byteCharacters = atob(base64.split(",")[1]);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  return new Blob([new Uint8Array(byteNumbers)], { type });
}

/* ---------- SYNC ---------- */
export async function syncAudiometry() {
  const backendReady = await isBackendReady();

  if (!backendReady) {
    console.log("⏸ Backend not reachable yet — waiting");
    return;
  }

  const db = await openDB();
  const tx = db.transaction("audiometry", "readwrite");
  const store = tx.objectStore("audiometry");
  const index = store.index("synced");

  const req = index.getAll(0);

  req.onsuccess = async () => {
    const records = req.result;

    for (const record of records) {
      try {
        let pdfBlob = null;

        if (record.pdf_base64) {
          pdfBlob = base64ToBlob(record.pdf_base64);
        }

        const normalizedFormData = {
          patient_excel_id: record.patient_excel_id,
          service_id: record.service_id,

          rightEarDB: record.rightEarDB,
          leftEarDB: record.leftEarDB,
          rightEarBoneDB: record.rightEarBoneDB,
          leftEarBoneDB: record.leftEarBoneDB,
          rightEarLevel: record.rightEarLevel,
          leftEarLevel: record.leftEarLevel,
        };

        await submitAudiometryData(
          normalizedFormData,
          pdfBlob,
          record.technician_id
        );

        record.synced = 1;

        const updateTx = db.transaction("audiometry", "readwrite");
        const updateStore = updateTx.objectStore("audiometry");
        updateStore.put(record);

        console.log("✅ Audiometry synced", record.patient_excel_id);

      } catch (error) {
        const status = error?.response?.status;

        if (status === 415 || status === 400) {
          record.synced = -1;

          const updateTx = db.transaction("audiometry", "readwrite");
          const updateStore = updateTx.objectStore("audiometry");
          updateStore.put(record);

          console.warn("🚫 Permanently failed audiometry", record.id);
        }
      }
    }
  };
}
